<div class="searchbox-holder">
	<div class="searchbox-widget">
		<ng-container *ngIf="showSearch; else defaultState">
			<cp-search-box-widget class="no-bgc"
								  (search)="onSearch($event);"
								  [debounce]="300"
								  [placeholderTranslationKey]="placeholderTranslationKey"
								  cpClickOut
								  (clickOut)="onClickOut();">
			</cp-search-box-widget>
		</ng-container>
		<ng-template #defaultState>
			<cp-button-widget-custom *ngIf="!showSearch"
									 class="form-icon-button"
									 [iconClass]="'cp-icon-search'"
									 [showPlaceHolder]="false"
									 [isDisabled]="disabled"
									 (click)="$event.stopPropagation()"
									 (onClick)="showSearch = !showSearch;">
			</cp-button-widget-custom>
		</ng-template>
	</div>
</div>
